// extracted by mini-css-extract-plugin
module.exports = {"moduleNumber":"CampModuleNumber_moduleNumber__Wiobu"};